import script from "./ContractsForms.vue?vue&type=script&setup=true&name=ContractForm&lang=ts"
export * from "./ContractsForms.vue?vue&type=script&setup=true&name=ContractForm&lang=ts"

import "./ContractsForms.vue?vue&type=style&index=0&id=de1f6e08&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de1f6e08"]])

export default __exports__